import Header from "@components/Header/Header"
import RadioButton from "@components/RadioButton/RadioButton"
import { useNavigate } from "react-router"
import { useState } from "react"
import { SUPPORTED_LANGUAGES } from "@constants/language"
import {
  Container,
  ContentContainer,
  LanguageTitle,
  LanguageListContainer,
  LanguageItemContainer,
  LanguageInfo,
  LanguageIcon,
  LanguageName,
  Divider
} from "./Language.styles"
import React from "react"
import { useLanguageStore } from "@stores/languageStore"
import { useTranslation } from "react-i18next"

const LanguageList = ({ language, iconUrl, checked, onChange }: { language: string, iconUrl: string, checked: boolean, onChange: (value: string) => void }) => {
    return (
        <LanguageItemContainer onClick={() => onChange(language)}>
            <LanguageInfo>
                <LanguageIcon src={iconUrl} alt={language} />
                <LanguageName>{language}</LanguageName>
            </LanguageInfo>
            <RadioButton 
                name="language" 
                value={language} 
                checked={checked}
                onChange={onChange}
                outlineColor="#550372"
                outlineWidth={1.5}
                centerColor="#550372"
                size={20}
                onClick={(e: React.MouseEvent) => e.stopPropagation()}
            />
        </LanguageItemContainer>
    )
}

const Language = () => {
  const navigate = useNavigate()
  const [selectedLanguage, setSelectedLanguage] = useState(useLanguageStore.getState().language)
  const { t } = useTranslation()

  const handleLanguageChange = (value: string) => {
    setSelectedLanguage(value)
    useLanguageStore.getState().changeLanguage(value)
    // Add any additional logic for language change here
  }

  return (
    <Container>
        <Header title={t('page.language.header')} onBackClick={() => navigate('/settings')} showBackButton />
        <ContentContainer>
            <LanguageTitle>
                {t('page.language.sectionTitle')}
            </LanguageTitle>
            <LanguageListContainer>
                {SUPPORTED_LANGUAGES.map((language, index) => {
                    return (
                        <React.Fragment key={index}>
                            <LanguageList 
                                language={language.language} 
                                iconUrl={language.iconUrl} 
                                checked={language.code === selectedLanguage} 
                                onChange={() => handleLanguageChange(language.code)}
                            />
                            {index !== SUPPORTED_LANGUAGES.length - 1 && <Divider />}
                        </React.Fragment>
                    )
                })}
            </LanguageListContainer>
        </ContentContainer>
    </Container>
  )
}

export default Language